import React, { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material";

import Loader from "components/common/Loader";
import Footer from "components/website/Footer";
import Header from "components/website/Header";
import { themeConfig } from "../../themeConfig";
import Notifier from "components/common/Notification";
import A11yMessage from "components/common/A11yMessage";

const theme = createTheme(themeConfig);

const WebsiteLayout = () => {
  return (
    <ThemeProvider theme={theme}>
      <Header />
      <Suspense fallback={<Loader />}>
        <Outlet />
      </Suspense>
      <Notifier />
      <A11yMessage />
      <Footer />
    </ThemeProvider>
  );
};

export default WebsiteLayout;
